export default [
  {
    sectionTitle: 'Assessments & Writing Tools',
    items: [
      {
        title: '16 Diagnostics: From EL to AP',
        tooltipText: 'ELL, Pre-AP, AP, and Springboard pre- and post-assessments, with weeks of recommended activities',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: '1,000+ Independent Practice Activities',
        tooltipText: 'Research-backed, 10-15 minute activities on capitalization, commas, compound sentences, text analysis, and more',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: '40+ Collaborative Full-Class Lessons',
        tooltipText: 'Teacher-led learning activities for whole class instruction, with built-in customizable slides and lesson plans',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
    ]
  },
  {
    sectionTitle: 'Data & Reporting',
    items: [
      {
        title: 'Proficiency Range, % Score, Completed Activities',
        tooltipText: 'Student performance reports with visual summaries of proficiency, scores, and completion, plus detailed views of prompts, responses, and feedback',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Diagnostic Results & Personalized Learning Plans',
        tooltipText: 'Diagnostic reports for assigning personalized learning plans, with student responses and scores included',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Scores By Standard',
        tooltipText: 'Reports that show which standards your Quill activities have covered and the proficiency status of each student',
        teacherBasic: false,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Scores By Grammar Concept',
        tooltipText: "Reports that show each student's proficiency in a range of grammar concepts",
        teacherBasic: false,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Data Export to .CSV',
        tooltipText: "Downloads of student data according to your specific needs, in PDF or CSV format",
        teacherBasic: false,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'School-Wide Usage Reports',
        tooltipText: "School-wide usage and diagnostic data, plus full access to teachers' dashboards",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true,
        hideOnTeacherPage: true
      },
      {
        title: 'School or District Assessment Reports on Gains',
        schoolPremiumTitle: 'School Assessment Reports: Pre to Post Learning Gains',
        districtPremiumTitle: 'District Assessment Reports: Pre to Post Learning Gains',
        tooltipText: "District-wide usage and diagnostic data, plus full access to teachers' dashboards",
        id: 'reportsOnGains',
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true,
        hideOnTeacherPage: true
      }
    ]
  },
  {
    sectionTitle: 'Professional Development & Support',
    items: [
      {
        title: 'Spotlight Webinars',
        tooltipText: '30 - 60 minute webinars to take a deep-dive into Quill features to help teachers leverage all features of Quill successfully',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Teacher Center Articles',
        tooltipText: '160+ best practices and implementation articles to improve your understanding and implementation of Quill',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Priority Technical Support',
        tooltipText: 'Support tickets identified with priority user status to resolve tech issues swiftly',
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Quill Academy: Self-Paced Literacy PD Courses',
        tooltipText: 'Self-paced professional development courses for educators, focused on research-based writing instruction and effective use of Quill',
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Two Interactive Professional Development Sessions',
        tooltipText: "Workshop-style live virtual PD focused on both research-based writing instruction and effective use of Quill",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: false,
        districtPremium: true
      },
      {
        title: 'Dedicated District Implementation Manager',
        tooltipText: "Dedicated CSM for personalized guidance and support throughout district implementation, focused on helping you achieve maximum results",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: false,
        districtPremium: true
      }
    ]
  },
  {
    sectionTitle: 'Rostering & Integrations',
    items: [
      {
        title: 'Google Classroom Sync',
        tooltipText: 'Rosters that allow students to log into Quill with Google credentials--plus, auto-sends announcements when you post assignments',
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Clever Library Sync',
        tooltipText: "A single sign on option where teachers can add the Quill app to students' Clever dashboards and sync their rosters",
        teacherBasic: true,
        teacherPremium: true,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Clever Secure Sync',
        tooltipText: "A single sign on option that lets schools or districts automatically sync teacher's Clever rosters with their Quill classes",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true
      },
      {
        title: 'Canvas Rostering',
        tooltipText: "A single sign on option that lets schools or districts automatically sync teacher's Canvas rosters with their Quill classes",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true
      },
      // TODO add this in once ClassLink is live
      // {
      //   title: 'ClassLink Rostering',
      //   tooltipText: "A single sign on option that lets schools or districts automatically sync teacher's ClassLink rosters with their Quill classes",
      //   teacherBasic: false,
      //   teacherPremium: false,
      //   schoolPremium: true,
      //   districtPremium: true
      // },
      {
        title: 'Unlimited Teacher & Student Licenses',
        tooltipText: "All teachers in the school or district receive Premium access for consistent implementation in writing courses",
        teacherBasic: false,
        teacherPremium: false,
        schoolPremium: true,
        districtPremium: true
      },
    ]
  }
]
